// @flow strict
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
/* eslint import/no-webpack-loader-syntax: off */
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './overrides.css';

import type { Edges } from '../../../types';


type Props = {
  customerLogos: Edges,
  isIndex?: boolean,
};

const CustomerCarousel = ({ customerLogos, isIndex }: Props) => {
  if (!isIndex) {
    return (null);
  }
  return (
    <div><h4 className="carousel-heading">Collaborations</h4>
    <Carousel
      showThumbs={false}
      showIndicators={false}
      showArrows={false}
      showStatus={false}
      autoPlay={true}
      dynamicHeight={true}
      infiniteLoop={true}
    >
      {customerLogos.map((file) => (
        <div key={file.node.id} >
            <img src={`${file.node.root}${file.node.sourceInstanceName}/${file.node.relativePath}`} />
        </div>
      ))}
    </Carousel>
    </div>
  );
};

export default CustomerCarousel;
